import React from 'react';
import PropTypes from 'prop-types';

import IntegrationItemPresenter from '../../../../../../presenters/FastCash/IntegrationItemPresenter';
import Row from '../../../../../../components/Row';
import Value from '../../../../../../components/Value';
import Column from '../../../../../../components/Column';
import { checkAndUpdateStatus } from '../../../../../../mutations';

const IntegrationItem = (props) => {
  const { item, relay, onFetchTransactions, onPlaidDialogOpen, searchParams } =
    props;

  const handleStatusCheck = () => {
    const params = {
      ...searchParams,
      integrationItemId: IntegrationItemPresenter.id(item),
    };

    checkAndUpdateStatus(relay.environment, params, {
      onCompleted: handleCheckSuccess,
    });
  };

  const handleCheckSuccess = (response) => {
    const {
      checkAndUpdateStatus: { errorMessage, successMessage },
    } = response;
    if (errorMessage) {
      window.alert(errorMessage);
    }
    if (successMessage) {
      window.alert(successMessage);
    }
  };

  const handleFetchTransactions = () => onFetchTransactions(item);
  const handleRemoveAccountClick = () => onPlaidDialogOpen(item);

  return (
    <div>
      <div className="form-group form-header">
        <h3>{IntegrationItemPresenter.institutionName(item)}</h3>
        <div className="account-actions">
          <div
            id="checkAndUpdateStatus"
            className="button -check-button -in-group"
            onClick={handleStatusCheck}
          >
            Check Plaid Account Status
          </div>
          <div
            id="fetchPlaidTransactions"
            className="button -in-group"
            onClick={handleFetchTransactions}
          >
            Fetch Transactions
          </div>
          <div
            id="removePlaidAccount"
            className="button delete"
            onClick={handleRemoveAccountClick}
          >
            Delete Plaid Account
          </div>
        </div>
      </div>
      <Row>
        <Column>
          <Value attr="plaidItemId" title="Plaid Item Id">
            {IntegrationItemPresenter.itemId(item)}
          </Value>
          <Value attr="accountOnboardedAt" title="Account Onboarded At">
            {IntegrationItemPresenter.accountOnboardedAtReadable(item)}
          </Value>
        </Column>
        <Column>
          <Value attr="errorState" title="Item State">
            {IntegrationItemPresenter.plaidState(item)}
          </Value>
        </Column>
      </Row>
    </div>
  );
};

export default IntegrationItem;

IntegrationItem.propTypes = {
  item: IntegrationItemPresenter.shape().isRequired,
  searchParams: PropTypes.shape().isRequired,
  relay: PropTypes.shape().isRequired,
  onFetchTransactions: PropTypes.func.isRequired,
  onPlaidDialogOpen: PropTypes.func.isRequired,
};
